import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles(() => ({
	backdrop: {
		zIndex: 9000,
	},
}));

/**
 * @param {import('@mui/material').BackdropProps} props
 */
function LoadingScreen({ className: propsClass, ...other }) {
	const classes = useStyles();
	return (
		<Backdrop
			open
			className={classNames(classes.backdrop, propsClass)}
			{...other}
		>
			<CircularProgress />
		</Backdrop>
	);
}

export default LoadingScreen;